// extracted by mini-css-extract-plugin
export default {"container":"Tu6Y5I","select":"GSbjNU","share-buttons":"oZZJGX","shareButtons":"oZZJGX","icon":"kMyL6w"};